// Generated by CoffeeScript 2.7.0
var Assignment;

import AssignmentMixin from 'trunks/vue/share/mixins/yet_another_workflow/assignment.js';

import AssignmentResponse from 'trunks/vue/admin/compositions/responseables/assignment.js';

export default Assignment = Vue.extend({
  mixins: [AssignmentMixin],
  components: {
    'assignment-response': AssignmentResponse
  },
  template: `<div class="assignment-response-wrapper"
     v-if="currentVertex.dig('operations', 'comment', 'enabled') || currentVertex.fields.length">
  <div class="assignment-response-label">需要我填写的</div>
  <div class="form-field-group">
    <div
      v-if="currentVertex.dig('operations', 'comment', 'enabled')"
      :class="commentFieldClass"
      class="form-field"
    >
      <div class="form-field-head">
        <div class="form-field-title">{{ currentVertex.dig('operations', 'comment', 'name') || 处理附言 }}</div>
      </div>
      <div class="form-field-input-container">
        <div class="form-field-input">
          <div class="advance-textarea form-field-value">
            <pre class="textarea-pre">{{ comment }}</pre>
            <textarea v-model='comment'
                      rows='9'
                      :placeholder='placeholderText'></textarea>
          </div>
        </div>
      </div>
    </div>
    <assignment-response :responseable='currentVertex'
                          :assignmentResponse='assignment.response'
                          ref='responseRef'/>
  </div>
</div>`
});
